/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2021-11-30 13:58:17
 * @Description: 
 */

import React from "react";
import "./NoImageMask.scss"
import { AddPicturePng } from "src/assets"
import FTButton from "src/components/FTButton/FTButton";
import FTLang from "src/utils/FTLang";
import utils, { hanldelFTUserProfile } from "src/utils";
import FTImageStore from "src/store/FTImageStore";
import FTCanvasStore from "src/store/FTCanvasStore";
import { message } from "antd";
import FTAnalytic from "src/analyze/FTAnalytic";
import FTFotorFeatureDB from "src/utils/FTFotorFeatureDB";
import qs from 'qs';

class NoImageMask extends React.Component {

  uploadImage = async (e: any) => {
    e.preventDefault && e.preventDefault()
    e.stopPropagation && e.stopPropagation()
    FTImageStore.uploadImage("goart_noimage")
  }

  componentDidMount(): void {
		const page = qs.parse(window.location.search.slice(1));
    async function getIndex(db_key:string){
    await FTFotorFeatureDB.initDB();
		const data = await FTFotorFeatureDB.getCacheData(db_key);
    FTImageStore.uploadImage('goart_noimage',data)
    }

    function send(url:string){
      var blob:Blob;
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url);
      xhr.setRequestHeader('Accept', 'image/jpeg');
      xhr.responseType = "blob";
      // 加载时处理
      xhr.onload = () => {
        // 获取返回结果
          blob = xhr.response;
          let file= new File([blob], 'fotor.jpg', { type: 'image/jpeg' });
          FTImageStore.uploadImage('goart_noimage',file)

          // 返回结果
      };
      xhr.onerror = (e) => {
      };
      // 发送
      xhr.send();
    }

    let hasClear=false
    if(page?.db_key){
      hasClear=true
      getIndex(page.db_key as string)
    }

    if(page?.bg_url){
      hasClear=true
      send(page.bg_url as string)
    }

   if(hasClear){
		window.history.replaceState(null, '', window.location.pathname);
   }


  }

  dropImage = async (e: any) => {
    if(e.dataTransfer && e.dataTransfer.files.length) {
      FTAnalytic.addAnalytic({
        type: 'ev',
        analyticType: "sa",
        action: 'fotor_web$callback$goart_import_image',
        label: {
          position: "goart_noimage_drop",
          is_success: true
        }
      })
      hanldelFTUserProfile()
      FTCanvasStore.changeLoading(true)
      let file = e.dataTransfer.files[0]
      if(!utils.checkFileType(file)) {
        message.error(FTLang._("goart_image_upload_errror"))
        FTCanvasStore.changeLoading(false)
        return
      }
      let {canvas: imageElement, acturalSize, currentSize}  = await utils.getImageFromFile(file);
      FTImageStore.setCurrentImageElement(imageElement, currentSize, acturalSize)
      FTImageStore.setCurrentImage(file)
      let effect = FTImageStore.effectClassifyMap.length && FTImageStore.effectClassifyMap[0].list[0]
      effect && FTImageStore.getGoartEffect(effect)
      effect && FTAnalytic.addAnalytic({
        type: 'ev',
        analyticType: "sa",
        action: 'fotor_web$click_up$goart_project_effects',
        label: {
          resource_id: utils.toFixed(effect.id, 0),
          resource_name: effect.name,
        }
      })
      FTCanvasStore.changeLoading(false)
    } else {
      FTAnalytic.addAnalytic({
        type: 'ev',
        analyticType: "sa",
        action: 'fotor_web$callback$goart_import_image',
        label: {
          position: "goart_noimage_drop",
          is_success: false
        }
      })
    }
  }




  render() {
    return <div className="noimage" onDrop={this.dropImage} onClick={(e) => this.uploadImage(e)}>
      <div className="noimage_center">
        <div className="noimage_icon">
          <img src={AddPicturePng} alt="" />
        </div>
        <div className="noimage_text">
          {FTLang._("goart_drag_open")}
        </div>
        <FTButton type="primary" className="noimage_btn" onClick={(e) => this.uploadImage(e)}>
          <span> { FTLang._("goart_open_image") } </span>
        </FTButton>
      </div>
    </div>
  }
}

export default NoImageMask